import webClient from "../config/api.config";
import {
  DoctorAdminSearchParams,
  GrantFreeAccessPayload,
} from "../types/doctorAdmin.definition";

export function requestSearchAdminDoctors(params: DoctorAdminSearchParams) {
  return webClient.request({
    method: "get",
    url: `/admin/doctors`,
    params,
  });
}

export function requestGetAdminDoctorDetail(doctorId: number | string) {
  return webClient.request({
    method: "get",
    url: `/admin/doctors/${doctorId}`,
  });
}

// MED-1253: grant (or extend) free access + change history.

export function requestGrantFreeAccess(
  doctorId: number | string,
  data: GrantFreeAccessPayload
) {
  return webClient.request({
    method: "post",
    url: `/admin/doctors/${doctorId}/licence/free-access`,
    data,
  });
}

export function requestGetDoctorGrantHistory(doctorId: number | string) {
  return webClient.request({
    method: "get",
    url: `/admin/doctors/${doctorId}/licence/grant-history`,
  });
}

// MED-1254: SMS notification diagnostics (enabled, consent, phone verified).

export function requestGetAdminDoctorSmsStatus(doctorId: number | string) {
  return webClient.request({
    method: "get",
    url: `/admin/doctors/${doctorId}/sms-status`,
  });
}

// MED-1255: audit log of sensitive admin actions taken on a doctor's account.

export function requestGetDoctorAdminActionAudit(doctorId: number | string) {
  return webClient.request({
    method: "get",
    url: `/admin/doctors/${doctorId}/admin-action-audit`,
  });
}
